import React from 'react';

export const LoadingSpinner = ({ ...pros }) => {
    return (
        <React.Fragment>
            <div {...pros} className="spinner-border" role="status"></div>
        </React.Fragment>
    );
};
